import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const EPublication = () => {
     useEffect(() => {
        document.title = 'E-Publication -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li>  
     <li> E-Publication</li>  
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>E-Publication  </h1>
         </div>
     </div>
     <div className="row">
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1DjhCi7Faj4Fid6zsd5scno8J-zC_5Ebf/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/ukg-e-publication.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3>Class UKG </h3> 
                 </div> 
         </Link>  
       </div> 
     </div> 
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1ovMmZ54bEza6Np7dpMVuXjr16850oh4d/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/lkg-e-publication.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3>Class LKG </h3> 
                 </div> 
         </Link>  
       </div> 
     </div> 
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1IRQXpec59JPH9y57h1xsOz2-L-Q2OCl4/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/nursery-e-publication.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3>Class Nursery </h3> 
                 </div> 
         </Link>  
       </div> 
     </div> 
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1BkSsdLyv55rUTRl-t0huelwMU9_5Aq43/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/1-e-publication.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3>Class I </h3> 
                 </div> 
         </Link>  
       </div> 
     </div> 
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1jNABCEpz1Z4cSX67I0ToKOjpMo8Lgd7s/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/2-e-publication.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3>Class II </h3> 
                 </div> 
         </Link>  
       </div> 
     </div> 

     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1dsA5RGG0hTdFVETVAOS1KHC1oBSTEz0a/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/3-e-publication.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3>Class III </h3> 
                 </div> 
         </Link>  
       </div> 
     </div> 
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/18bpMv1suyO2ZEL8PgBrpCNsq2rcBrl5t/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/4-e-publication.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3>Class IV </h3> 
                 </div> 
         </Link>  
       </div> 
     </div> 
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1YxCUbaR6HiRJ8mDipXEwsnz36n3JZRyK/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/5-e-publication.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3>Class V </h3> 
                 </div> 
         </Link>  
       </div> 
     </div> 

     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1sRSQ9tRLrx0k_3B-3K93Pc7g2AMCOD4S/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/6-e-publication.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3>Class VI </h3> 
                 </div> 
         </Link>  
       </div> 
     </div> 
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1w7sz64Ig2LOJAl-Z53x_Hvfjpxyy9mPe/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/7-e-publication.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3>Class VII </h3> 
                 </div> 
         </Link>  
       </div> 
     </div> 
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/16hK60SmKt9K74Zoa1heqA0b5n8gmQ0fi/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/8-e-publication.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3>Class VIII </h3> 
                 </div> 
         </Link>  
       </div> 
     </div> 
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1iS7IxK2uTFvYh3urvdac1p6wZQrlmn87/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/9-e-publication.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3>Class IX </h3> 
                 </div> 
         </Link>  
       </div> 
     </div> 
     {/* <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1sRSQ9tRLrx0k_3B-3K93Pc7g2AMCOD4S/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/EPublication1.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3>Class X </h3> 
                 </div> 
         </Link>  
       </div> 
     </div>  */}

{/*      
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1LB69mA2Ba0iojdsZUGU5p6BJPaQJCqxz/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/EPublication1.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3>Class III </h3> 
                 </div> 
         </Link>  
       </div> 
     </div> 
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1ECqiZvScSgyhTvUZNvGBmJLu4wjah25Y/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/EPublication2.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3> Class IV </h3> 
                 </div> 
         </Link>  
       </div> 
     </div> 
       <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1ZRuWzsF_E4rkhG5YOUgK-F_zO27_kz3z/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/EPublication5.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3> Class V </h3> 
                 </div> 
         </Link>  
       </div> 
     </div> 
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1I8gOqV3_ABjC1P9lcN1fnIo8Fo0kskmr/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/EPublication6.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3> Class VI </h3> 
                 </div> 
         </Link>  
       </div> 
     </div> 
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1UGdKSBsiHIxjd748AGA7br3gjF5n7Kaw/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/EPublication7.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3>  Class VII</h3> 
                 </div> 
         </Link>  
       </div> 
     </div>
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1-hkcjwHXMzG_bI_zo_NuGme4vwrUVSFn/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/EPublication3.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3> Class VIII</h3> 
                 </div> 
         </Link>  
       </div> 
     </div> 
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">  
        <Link to="https://drive.google.com/file/d/1PxxLz7RJ1JoqkhZmu_8npNpOZEvwB-iP/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/EPublication4.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div> 
                 <h3> Class IX </h3> 
                 </div> 
         </Link>  
       </div> 
     </div>  */}
    
     
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default EPublication
